import request from '../../utils/request'

export default {
    // getRequest: function (data) {
    //     return request({
    //         url: "/react/getDataSouceList",
    //         // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //         method: 'get',
    //         params: data,
    //     })
    // },
    getApiData(data) {
        return request({
            url: "/dataSource/getApiData",
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: 'Post',
            params: data,
        })
    },
    addDataSource(data) {
        return request({
            url: "/dataSource/addDataSource",
            method: 'Post',
            params: data,
            headers: { token: sessionStorage.getItem("token") },
        })
    },
    getDataSourceList() {
        return request({
            url: "/dataSource/getDataSourceList",
            method: 'get',
            headers: { token: sessionStorage.getItem("token") },
        })
    },
    getDataSourceById(data) {
        return request({
            url: "/dataSource/getDataSourceById",
            method: 'get',
            params: data,
        })
    },
    removeDataSource(data) {
        return request({
            url: "/dataSource/removeDataSource",
            method: 'get',
            params: data,
        })
    },
    editDataSource(data) {
        return request({
            url: "/dataSource/editDataSource",
            method: 'get',
            params: data,
        })
    },
    editDataSourceData(data) {
        return request({
            url: "/dataSource/editDataSourceData",
            method: 'post',
            data,
        })
    },
    uploadDataSourceFile(data) {
        return request({
            url: "/dataSource/uploadDataSourceFile",
            method: 'Post',
            data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/dataSource.js